import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AlertService, AppAlert } from '../../core/services/alert';

@Component({
  selector: 'app-alerts',
  standalone: false,
  templateUrl: './alerts.html',
  styleUrl: './alerts.scss',
})
export class Alerts {
  readonly alerts$: Observable<ReadonlyArray<AppAlert>>;
  readonly visibleAlerts$: Observable<ReadonlyArray<AppAlert>>;

  constructor(
    readonly alertService: AlertService,
    private readonly router: Router,
  ) {
    this.alerts$ = this.alertService.alerts$;
    this.visibleAlerts$ = this.alerts$.pipe(map((alerts) => alerts.slice(0, 5)));
  }

  get hasConfigurationOffset(): boolean {
    return this.router.url.startsWith('/configuration');
  }

  severityLabel(alert: AppAlert): string {
    if (alert.title) return alert.title;
    return alert.severity === 'danger'
      ? 'Error'
      : alert.severity.charAt(0).toUpperCase() + alert.severity.slice(1);
  }

  trackAlert(_index: number, alert: AppAlert): string {
    return alert.id;
  }
}
